import { FunctionComponent } from 'react'

import styled from 'styled-components'

import FreeRatioImage from '@components/FreeRatioImage'

const LOGO_IMAGE = {
  src: '/incoming/21344730-v0-zattoo-brand.png',
  alt: 'Zattoo Logo',
  width: 75,
  height: 29,
  crops: {},
} as const

const expectedDimensions = { width: 75, height: 29 } as const

const constraints = {
  desktop: expectedDimensions,
  tablet: expectedDimensions,
  mobile: expectedDimensions,
  mobileSmall: expectedDimensions,
} as const

const StyledZattooLogoImage = styled(FreeRatioImage)`
  position: absolute;
  right: 10px;
  bottom: 10px;
`

const ZattooLogoImage: FunctionComponent = () => (
  <StyledZattooLogoImage
    src={LOGO_IMAGE.src}
    alt={LOGO_IMAGE.alt}
    crops={LOGO_IMAGE.crops}
    originalDimensions={{
      width: LOGO_IMAGE.width,
      height: LOGO_IMAGE.height,
    }}
    constraints={constraints}
  />
)

export default ZattooLogoImage
